/* oxlint-disable typescript/consistent-type-assertions -- partial GraphQL responses are typed at call site */
import { ClientError, GraphQLClient } from 'graphql-request';
// oxlint-disable-next-line sort-imports
import type { TypedDocumentNode, Variables, GraphQLClientOptions } from './types';

let client: GraphQLClient | null = null;

export const base = async <T, V extends Variables>(
  document: TypedDocumentNode<T, V>,
  variables: V,
  options: GraphQLClientOptions
): Promise<T> => {
  if (!client) {
    throw new Error('graphQLClient.init must be called before running any query');
  }

  const { allowPartialData, ...requestOptions } = options;

  try {
    return await client.request<T>({
      ...requestOptions,
      document,
      variables,
    });
  } catch (error) {
    if (allowPartialData && error instanceof ClientError) {
      if (!error.response.data) {
        throw new Error('GraphQL response has no data');
      }
      return error.response.data as T;
    }
    throw error;
  }
};

base.init = (endpointUrl: string): void => {
  client = new GraphQLClient(endpointUrl, {
    method: 'POST',
    credentials: 'include',
  });
};
